import FacetFilterState from '../../FacetFilterState';

export default class ColorFacetFilterState extends FacetFilterState {}
